import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "eaytb3e0",
    dataset: "production"
});